import styled from "styled-components";
import { media } from "@/theme/breakpoints";

const accent = "#E8521A";
const accentGreen = "#16a34a";

export const PageRoot = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 24px 48px;
  box-sizing: border-box;

  ${media.downMobile`
    padding: 20px 16px 32px;
  `}
`;

export const PageHeader = styled.div`
  margin-bottom: 28px;
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #111;
`;

export const PageSub = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  color: #6b7280;
  line-height: 1.5;
`;

export const SupplierGrid = styled.div`
  display: grid;
  gap: 16px;
`;

export const SupplierCard = styled.article`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const SupplierMain = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SupplierAvatar = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: ${accent};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Syne, sans-serif;
  font-size: 15px;
  font-weight: 800;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
`;

export const SupplierName = styled.h2`
  margin: 0 0 4px;
  font-family: Syne, sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #111;
`;

export const SupplierMeta = styled.p`
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
`;

export const VerifiedBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  background: ${(p) => (p.$muted ? "#f3f4f6" : "#dcfce7")};
  color: ${(p) => (p.$muted ? "#6b7280" : accentGreen)};
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  ${media.downMobile`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const MetricCard = styled.div`
  background: #f9fafb;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 12px 10px;
  text-align: center;
`;

export const MetricValue = styled.div`
  font-family: Syne, sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: ${(p) => p.$tone || "#111"};
  margin-bottom: 4px;
`;

export const MetricLabel = styled.div`
  font-size: 10px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
  border: 1px dashed #dfe3e8;
  border-radius: 12px;
  color: #6b7280;
  font-family: Inter, sans-serif;
`;
